import { useEffect, useState } from "react";

/**
 * Mirrors `active`, but delayed on the rising edge — so a loading indicator
 * driven by it never flashes for a fast response, only for one that actually
 * stalls past `delayMs`. Falls back to `false` immediately once `active`
 * clears.
 */
export function useDelayedFlag(active: boolean, delayMs: number): boolean {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!active) {
      setVisible(false);
      return;
    }
    const timer = setTimeout(() => setVisible(true), delayMs);
    return () => clearTimeout(timer);
  }, [active, delayMs]);

  return visible;
}
